import { defineMessages } from 'react-intl';

export default defineMessages({
    yourProfileAndSettings: {
        id: 'layout.user-avatar.your-profile-and-settings',
        defaultMessage: 'Your profile and settings',
        description: 'Accessibility label for profile & settings avatar',
    },
});
